<template>
  <mdb-container class="gp-has-header text-left">
    <div v-if="!showHistory">
      <h2>Simple Storage Endpoints</h2>
      <mdb-btn size="sm" @click="add" icon="plus-circle">New Endpoint</mdb-btn>
      <mdb-tbl striped responsive>
        <mdb-tbl-head class="primary-color text-white">
          <tr>
            <th>Key</th>
            <th>Description</th>
            <th>Secret</th>
            <th style="width:10%;">&nbsp;</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="e in endpoints" :key="e.id">
            <td>{{ e.storeKey }}</td>
            <td>{{ e.description }}</td>
            <td>{{ e.storeSecret }}</td>
            <td>
              <mdb-btn @click="editItem(e)" title="Edit" icon="pencil" size="sm" tag="a" floating rounded/>
              <mdb-btn @click="getHistory(e)" title="Show Recent Data" icon="clock-rotate-left" size="sm" tag="a"
                       floating rounded/>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>

    <div v-if="showHistory">
      <h2>History</h2>
      <mdb-btn size="sm" @click="showHistory=false" icon="arrow-left">Back</mdb-btn>
      <mdb-tbl striped responsive>
        <mdb-tbl-head class="primary-color text-white">
          <tr>
            <th>Date</th>
            <th>IP Address</th>
            <th style="width:75%">Value</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="h in history" :key="h.id">
            <td>{{ h.lastUpdated }}</td>
            <td>{{ h.ipAddress }}</td>
            <td>
              <span v-if="!h.isJson">{{h.value}}</span>
              <span v-if="h.isJson && !h.showingJson"><mdb-btn @click="h.showingJson=true" icon="eye" size="sm" rounded>Show JSON</mdb-btn></span>
              <span v-if="h.isJson && h.showingJson"><mdb-btn @click="h.showingJson=false" icon="eye-slash" size="sm" rounded>Hide JSON</mdb-btn></span>
              <pre v-if="h.showingJson">{{ JSON.stringify(h.value, null, 2)}} </pre>

            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>

    <mdb-modal v-if="editModal" @close="editModal = false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Edit Endpoint
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="working.storeKey" label="Key"/>
        <mdb-input v-model="working.description" label="Description"/>
        <mdb-input v-model="working.storeSecret" label="Secret"/>
        <div class="text-info">Leave secret empty for an auto-generated secure UUID</div>
        <mdb-btn :disabled="!working.storeKey || !working.description" @click="save" icon="save" size="sm">Save
        </mdb-btn>
        <mdb-btn @click="editModal=false" icon="minus-circle" size="sm" color="warning">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>
<script>
import {
  mdbBtn,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import YesNoModal from "../common/YesNoModal";

export default {
  name: "simple-storage-endpoint",
  display: "Simple Storage Endpoint",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    YesNoModal
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {
    this.loadEndpoints()
  },
  data() {
    return {
      endpoints: [],
      editing: null,
      working: null,
      editModal: false,
      showHistory: false,
      history: []
    }
  },
  methods: {
    add() {
      this.working = {storeKey: "", storeSecret: "", description: ""}
      this.editModal = true
    },
    editItem(i) {
      this.editing = i
      this.working = JSON.parse(JSON.stringify(i))
      this.editModal = true
    },
    getHistory(e) {
      this.$store.dispatch("setExecuting", true)
      api.get("/admin/storageHistory/" + e.id).then(
        (results) => {
          this.history = []
          for (let d of results.data) {
            let row = d
            d.showingJson = false
            try {
              //d.value = JSON.parse(d.value, null, 2)
              d.value = JSON.parse(d.value)
              d.isJson = true
            }
            catch(e) {
              d.isJson = false
            }
            this.history.push(row)
          }
          this.showHistory = true
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },


    save() {
      this.$store.dispatch("setExecuting", true)
      this.editModal = false
      this.addModal = false
      api.post("/admin/storageEndpoint", this.working).then(
        (results) => {
          if (this.working.id) {
            this.editing.storeKey = results.data.storeKey
            this.editing.storeSecret = results.data.storeSecret
            this.editing.description = results.data.description
          } else {
            this.endpoints.unshift(results.data)
          }
          this.working = null
          this.editing = null
        },
        (error) => {
          this.$notify.error({message: error.response.data})
          if (this.working.id) this.editModal = true
          else this.addModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    loadEndpoints() {
      this.$store.dispatch("setExecuting", true)
      api.get("/admin/storageEndpoints").then(
        (results) => {
          this.endpoints = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
;
</script>
